import type { SupabaseClient as SupabaseClientBase } from '@supabase/supabase-js';
import { Database } from './db.ts';

export type SupabaseClient = SupabaseClientBase<Database>;

type SupabaseResponse<TData = unknown, TError = unknown> = { data?: TData, error?: TError };
type SupabasePromise<TData, TError> = PromiseLike<SupabaseResponse<TData, TError>>;

export async function wrapSupabase<TData = unknown, TError = Error>(worker: SupabasePromise<TData, TError>) {
    const { data, error } = await worker;

    if (error) {
        throw error;
    }

    return data;
}
